import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationMsgPipe } from './pipes/validation-msg.pipe';
import { TranslatorPipe } from './pipes/translator.pipe';

@NgModule({
  declarations: [ValidationMsgPipe, TranslatorPipe],
  imports: [CommonModule],
  exports: [ValidationMsgPipe, TranslatorPipe],
})
export class SharedUtilsModule {}
